<template>
  <!-- 左侧部分 -->
  <div>
    <div class="cockpit-title">
      园区运营分析
      <img src="../../../public/assets/assets/img/more.png" class="more" />
    </div>
    <div style="padding: 0 20px">
      <!-- 房屋租赁统计 -->
      <div class="count">
        <div class="flex f14">
          <i class="cockpit-icon icon_1"></i>
          房屋租赁统计
        </div>
        <div class="data-content">
          <div class="fw-data flex">
            <div class="fw data-item" v-for="item in d1" :key="item.id" @click="showDetail('Room', item)">
              <p class="num">{{ item.num }}</p>
              <p>{{ item.desc }}</p>
              <div class="data-detail" v-if="item.txt">{{ item.txt }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 企业统计 -->
      <div class="count">
        <div class="flex f14">
          <i class="cockpit-icon icon_2"></i>
          企业统计
        </div>
        <div class="data-content">
          <div class="fw-data flex">
            <div class="qy data-item" v-for="item in d2" :key="item.id" @click="showDetail('Company', item)">
              <p class="num">{{ item.num }}</p>
              <p>{{ item.desc }}</p>
              <div class="data-detail" v-if="item.txt">{{ item.txt }}</div>

            </div>
          </div>
        </div>
      </div>

      <!-- 耗能统计 -->
      <div class="count">
        <div class="flex f14">
          <i class="cockpit-icon icon_3"></i>
          耗能统计
        </div>
        <div class="data-content">
          <div class="fw-data flex">
            <div class="hn data-item" v-for="item in d3" :key="item.id">
              <p class="num">
                {{ item.num }}<span class="unit">{{ item.unit }}</span>
              </p>
              <p>{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="flex">
        <!-- 房屋收入统计 -->
        <div class="count">
          <div class="flex f14">
            <i class="cockpit-icon icon_4"></i>
            房屋收入统计
          </div>
          <div class="data-content">
            <div class="fw-data flex">
              <div class="fwsr data-item" v-for="item in d4" :key="item.id" @click="showDetail('Receipt', item)">
                <p class="num">
                  {{ item.num | fixed2 }}<span class="unit" v-if="item.unit">{{ item.unit }}</span>
                </p>
                <p>{{ item.desc }}</p>
                <div class="data-detail" v-if="item.txt">{{ item.txt }}</div>

              </div>
            </div>
          </div>
        </div>

        <!-- 停车费统计 -->
        <div class="count">
          <div class="flex f14">
            <i class="cockpit-icon icon_5"></i>
            停车费统计
          </div>
          <div class="data-content">
            <div class="fw-data flex">
              <div class="tcf data-item" v-for="item in d5" :key="item.id">
                <p class="num">
                  {{ item.num }}<span class="unit" v-if="item.unit">{{ item.unit }}</span>
                </p>
                <p>{{ item.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-drawer :visible.sync="detailDia" size="60%" :withHeader="false" :close-on-click-modal="false"
      :destroy-on-close="true" :modal-append-to-body="false" :wrapperClosable="false">
      <div class="bor-b detail">
        <div class="de-title">{{ detailTitle }}详细数据</div>
        <Room v-if="type == 'Room'" :status="roomStatus" />
        <Company v-else-if="type == 'Company'" :table="company.table" :type="company.type" />
        <Receipt v-else-if="type == 'Receipt'" :type="roomStatus" />
        <RepairAndProblem v-else :type="roomStatus" />
      </div>
      <el-footer class="bor-t lh-49" height="50px">
        <div class="pull-right">
          <template>
            <el-button size="small" type="primary" @click="detailDia = false">关 闭</el-button>
          </template>
        </div>
      </el-footer>
    </el-drawer>
  </div>
</template>

<script>
import { getMetaCommonList } from "@/api/busiMode/metaCommon"
import Room from './detail/room.vue'
import Company from './detail/company.vue'

import Receipt from './../reportForms/detail/index.vue'

export default {
  props: {
    once: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFullscreen: false,
      /** 房屋租赁统计 **/
      d1: [
        { id: "building_num", num: "0", desc: "楼宇数" },
        { id: "room_num", num: "0", desc: "房间总数", txt: '统计系统中的有产权房及虚拟房', status: 'all' },
        { id: "syl", num: "35%", desc: "使用率", txt: '（已租+已售+自用）/ 建筑面积' },
        { id: "floorage", num: "0", desc: "建筑面积（㎡）", txt: '根据房本信息录入的楼宇总面积', status: '' },
        { id: "sum_room_area_yz", num: "0", desc: "出租面积（㎡）", txt: '已出租的房间面积总和', status: 1 },
        { id: "sum_room_area_wz", num: "0", desc: "空置面积（㎡）" },
        { id: "sum_room_area_ys", num: "0", desc: "已售面积（㎡）", txt: '已售状态的房间面积总和', status: 2 },
        { id: "sum_room_area_zy", num: "0", desc: "自用面积（㎡）", txt: '自用状态的房间面积总和', status: 3 },
      ],
      /** 企业统计 **/
      d2: [
        { table: 'wisdom_park.v_company_checkin_week', type: '1', id: "check_in_week", num: "2", desc: "上周入驻数", txt: '上周成功办理入驻的企业总数', status: 'all' },
        { table: 'wisdom_park.v_company_checkin_month', type: '1', id: "check_in_month", num: "10", desc: "本月入驻数", txt: '本月成功办理入驻的企业总数', status: 'all' },
        { table: 'wisdom_park.v_company_checkin_year', type: 'Y', id: "check_in_year", num: "30", desc: "本年度入驻数", txt: '本年成功办理入驻的企业总数', status: 'all' },
        { table: 'wisdom_park.v_company_checkout_week', type: '0', id: "check_out_week", num: "1", desc: "上周退出数", txt: '上周成功办理退出的企业总数', status: 'all' },
        { table: 'wisdom_park.v_company_checkout_month', type: '0', id: "check_out_month", num: "3", desc: "本月退出数", txt: '本月成功办理退出的企业总数', status: 'all' },
        { table: 'wisdom_park.v_company_checkout_year', type: 'Y', id: "check_out_year", num: "3", desc: "本年度退出数", txt: '本年成功办理退出的企业总数', status: 'all' },
        { table: 'wisdom_park.v_wp_company_valid', type: 'Y', id: "sum_checkin_num", num: "7", desc: "当前企业总数", txt: '截止到当前时间成功办理入驻且未退出的企业总数', status: 'all' },
        // { id: "d2_7", num: "280", desc: "已售面积（㎡）" },
      ],
      /** 耗能统计 **/
      d3: [
        { id: "electric_week", num: "0", desc: "上周用电量", unit: "万度" },
        { id: "electric_month", num: "0", desc: "本月用电量", unit: "万度" },
        { id: "electric_year", num: "0", desc: "本年度用电量", unit: "万度" },
        { id: "water_month", num: "0", desc: "上月用水量", unit: "吨" },
        { id: "water_year", num: "0", desc: "本年度用水量", unit: "吨" },
        // { id: "heating_week", num: "0", desc: "上周用暖量", unit: "吉焦" },
        { id: "heating_month", num: "0", desc: "本月用暖量", unit: "吉焦" },
        { id: "heating_year", num: "0", desc: "本年度用暖量", unit: "吉焦" },
        // { id: "water_week", num: "0", desc: "上周用水量", unit: "吨" },
      ],
      /** 房屋收入统计 **/
      d4: [
        { id: "ys_fz_week", num: "0", desc: "本周实收", unit: "万", txt: '近7天的房屋租赁实收', status: 'W' },
        { id: "ys_fz_month", num: "0", desc: "本月实收", unit: "万", txt: '本月房屋租赁实收', status: 'M' },
        { id: "yj_fz_sum", num: "0", desc: "本年度实收", unit: "万", txt: '本年度房屋租赁实收', status: 'Y' },
        { id: "ys_fz_sum", num: "0", desc: "本年度应收", unit: "万", txt: '本年度房屋租赁应收', status: '' },
        { id: "wcl", num: "10", desc: "完成率", unit: "", txt: '本年度实收 / 本年度应收', status: '' },
      ],
      /** 停车费统计 **/
      d5: [
        { id: "fee_week", num: "0", desc: "上周实收", unit: "万" },
        { id: "fee_month", num: "0", desc: "本月实收", unit: "万" },
        { id: "fee_year", num: "0", desc: "本年度实收", unit: "万" },
      ],
      detailTitle: '',
      detailDia: false,
      roomStatus: '',
      receiptDetail: false,
      receiptType: '',
      type: 'Room',
      company: {}
    }
  },

  components: { Room, Company, Receipt },

  mounted() {
    this.getMetaCommonList("v_jsc_wp_company_stat", "d2")
    this.getMetaCommonList("v_jsc_wp_park_stat", "d1")
    this.getMetaCommonList("v_jsc_wp_energy_consumption_stat", "d3")
    this.getMetaCommonList("v_jsc_wp_room_income_stat", "d4")
    this.getMetaCommonList("v_jsc_wp_parking_fee_stat", "d5")
  },

  filters: {
    fixed2(num) {
      return (num + "").includes("%") ? num : num == 0 ? "0.00" : Math.round(num * 100) / 100
    },
  },

  methods: {
    getMetaCommonList(view, name) {
      let b = {
        size: 1000,
        current: 1,
      }
      getMetaCommonList("wisdom_park." + view, b).then((res) => {
        const data = res.data.data
        if (name == "d2") {
          this.d2.forEach((e) => {
            for (let key in data.records[0]) {
              if (e.id == key) {
                e.num = data.records[0][key]
              }
            }
          })
        }
        if (name == "d1") {
          this.d1.forEach((e) => {
            for (let key in data.records[0]) {
              if (e.id == key) {
                if (key == "building_num") {
                  e.num = 17
                } else if (key == "syl") {
                  e.num = data.records[0][key] + " %"
                } else {
                  e.num = data.records[0][key]
                }
              }
            }
          })
        }
        if (name == "d3") {
          this.d3.forEach((e) => {
            for (let key in data.records[0]) {
              if (e.id == key) {
                e.num = data.records[0][key]
              }
            }
          })
        }
        if (name == "d4") {
          this.d4.forEach((e) => {
            for (let key in data.records[0]) {
              if (e.id == key) {
                e.num = data.records[0][key]
                if (key == "wcl") {
                  e.num = e.num + " %"
                }
              }
            }
          })
        }
        if (name == "d5") {
          this.d5.forEach((e) => {
            for (let key in data.records[0]) {
              if (e.id == key) {
                e.num = data.records[0][key]
              }
            }
          })
        }
      })
    },

    showDetail(type, item) {
      console.log(type)
      if (!this.once) this.$emit('handleToggle')
      this.type = type
      if (type == 'Company') this.company = item
      console.log(this.company)
      if (item.status) {
        this.detailTitle = item.desc
        this.roomStatus = item.status == 'all' ? '' : item.status
        this.detailDia = true
      }
    }
  },
}
</script>

<style scoped>
.cockpit-container .cockpit-left,
.cockpit-container .cockpit-right {
  height: 960px;
}

.cockpit-container .cockpit-left {
  width: 979px;
}

.cockpit-container .cockpit-right {
  width: 916px;
  padding: 0 5px;
}

.cockpit-container .cockpit-left {
  background: url(../../../public/assets/assets/img/bg001.svg) no-repeat 100%/100%;
}

.flex .f14 {
  margin-bottom: 10px;
}

/** 标题渐变色样式 **/
.cockpit-title {
  position: relative;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 20px;
  color: #fff;
  font-weight: bold;
  background: linear-gradient(90deg, rgba(0, 238, 255, 0.7) 0%, rgba(60, 165, 255, 0) 100%);
}

.cockpit-title img {
  width: 40px;
}

.mt {
  margin-top: 5px;
}

.cockpit-mid-title {
  padding: 15px;
}

.flex {
  display: flex;
  display: -webkit-flex;
  align-items: center;
}

/** 左侧 小框内容 **/
.data-content {
  display: flex;
  display: -webkit-flex;
  margin-top: 15px;
}

.data-item {
  position: relative;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 110px;
  height: 60px;
  margin-right: 8px;
}

.data-item>p.num {
  font-size: 18px;
  font-weight: bold;
}

.data-item>p {
  margin: 0px;
  margin-top: 5px;
  font-size: 11px;
}

/** 各种类型的单独样式 **/
.fw {
  background: url(../../../public/assets/assets/img/bg_icon_1.svg) 100% 100%;
}

.fw p.num {
  color: #00ffac;
}

.qy {
  background: url(../../../public/assets/assets/img/bg_icon_2.svg) 100% 100%;
}

.qy p.num {
  color: #00eeff;
}

.hn {
  background: url(../../../public/assets/assets/img/bg_icon_3.svg) 100% 100% no-repeat;
}

.hn.data-item {
  width: 126px;
}

.hn p.num {
  color: #40b3ff;
}

p.num span.unit {
  font-size: 10px;
  margin-left: 3px;
}

.fwsr {
  background: url(../../../public/assets/assets/img/bg_icon_4.svg) 100% 100% no-repeat;
}

.fwsr p.num {
  color: #f382ff;
}

.tcf {
  background: url(../../../public/assets/assets/img/bg_icon_5.svg) 100% 100% no-repeat;
}

.tcf p.num {
  color: #ffed7a;
}

/** 小图标 **/
.cockpit-icon {
  display: inline-block;
  width: 14px;
  height: 14px;
  margin-right: 5px;
}

.icon_1 {
  background: url(../../../public/assets/assets/img/icon_1.svg) 100%/100%;
}

.icon_2 {
  background: url(../../../public/assets/assets/img/icon_2.svg) 100%/100%;
}

.icon_3 {
  background: url(../../../public/assets/assets/img/icon_3.svg) 100%/100%;
}

.icon_4 {
  background: url(../../../public/assets/assets/img/icon_4.svg) 100%/100%;
}

.icon_5 {
  background: url(../../../public/assets/assets/img/icon_5.svg) 100%/100%;
}

.icon_6 {
  background: url(../../../public/assets/assets/img/icon_6.svg) 100%/100%;
}

.count {
  margin-top: 28px;
}

.mt20 {
  margin-top: 20px;
}

.cockpit-title.noback {
  background: none;
}

.data-detail {
  position: absolute;
  z-index: -1;
  height: 0;
  bottom: 15px;
  padding: 8px;
  text-align: center;
  background-color: #01829B;
  color: #fff;
  opacity: 0;
  border-radius: 5px;
  transform: scale(0);
  transition: all 0.5s linear;
}

.data-detail::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  border: 10px transparent solid;
  border-top-color: #01829B;
  transform: translateY(20px);

}

.data-item:hover .data-detail {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150%;
  height: 55px;
  line-height: 20px;
  z-index: 1;
  opacity: 1;
  transform: scale(1);
  transform: translateY(-60px);
}

.detail {
  color: #000000;
  padding: 0 15px;
}

.detail .de-title {
  font-size: 20px;
  font-weight: bold;
  line-height: 50px;
  margin-left: 15px;
  margin-bottom: 15px;
}
</style>
